import { Box, Divider as MuiDivider, styled } from '@mui/material';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';

export const Divider = styled(MuiDivider)`
  margin: 10px 0px;
`;

export const ContentContainer = styled(Box)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.primary.lighter,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.lighter,
    color: theme.palette.secondary.dark,
    fontSize: '1rem',
    width: '22.0625rem',
    height: 'auto',
    padding: '0.5rem',
    fontWeight: '300',
  },
}));

export const DarkTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.grey,
    color: theme.palette.common.white,
    fontSize: '1rem',
    width: '22.0625rem',
    height: 'auto',
    padding: '0.5rem',
    fontWeight: '300',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.grey,
  },
}));

export const VariationImagesTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ),
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.grey,
    color: theme.palette.common.white,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.grey,
  },
}));
